import { BaseContainerModel } from '../base-container.model';
import { bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_hdr_RowInterface } from '../../dbschema/bl_fi_mst_item_hdr.model';

export class ItemMappingContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowInterface = new bl_fi_mst_item_hdr_RowClass();
}